import React, { useState } from 'react';
import styles from './styles/ProductCard.module.css';
import { QuantitySelector } from './qtySelector';
import { priceTranslation, addToCartBtn, addedToCartBtn, retailtPrice, whPrice, whAddPrice, headerPriceTranslations } from '../../helpers/currency_helper';
import Tooltip from './ui/Tooltip';
import { getCurrencySymbol } from './utils/calcPrice';
import { ShoppingCart, Info } from 'lucide-react';

export const ProductCard = ({
  image,
  category,
  nomenclatureCode,
  title,
  description,
  composition,
  language,
  needle_gage,
  needle_mm,
  needle_type,
  thread_gage,
  thread_mm,
  thread_type,
  price_r,
  price_w,
  price_w_add,
  region,
  includeAddWPrice,
  includeWPrice,
  r_amount,
  w_amount,
  w_amount_add,
  onAddToCart
}) => {
  const [quantity, setQuantity] = useState(1);
  const [added, setAdded] = useState(false);
  const [selectedComposition, setSelectedComposition] = useState('');
  const [compositionError, setCompositionError] = useState(false);

  const handleAdd = () => {
    const parsedComposition = parseMesoneedleComposition(composition);
    if (category === 'Mesoneedles & Cannulas' && parsedComposition.length > 0 && !selectedComposition) {
      setCompositionError(true);
      return;
    }
    setCompositionError(false);
    const selectedIndex = parsedComposition.findIndex((item) => item === selectedComposition);
    onAddToCart(quantity, selectedComposition, selectedIndex);
    setAdded(true);
    setTimeout(() => setAdded(false), 1500); // reset after 1.5s
  };

  const parseMesoneedleComposition = (composition) => {
    try {
      const result = [];
      // Match patterns like: "32G (4mm, 13mm)" or "25G, 27G (13mm, 25mm)"
      const gaugeMatch = composition.match(/([\d]{2}G(?:,\s*[\d]{2}G)*)/);
      const lengthMatch = composition.match(/\(([^)]+)\)/);

      if (!gaugeMatch || !lengthMatch) return [];

      const gauges = gaugeMatch[1].split(',').map((g) => g.trim()); // ['25G', '27G']
      const lengths = lengthMatch[1].split(',').map((l) => l.trim()); // ['13mm', '25mm']
      for (const g of gauges) {
        for (const l of lengths) {
          result.push(`${g} ${l}`);
        }
      }

      return result;
    } catch (e) {
      return [];
    }
  };
  return (
    <>
      <div className={styles.productWrapper}>
        <div className={styles.productCard}>
          <div className={styles.productImageWrapper}>
            <img src={image} alt={title} className={styles.productImage} />
          </div>
          <div className={styles.productContent}>
            <span className={styles.productCategory}>{category}</span>
            <span className={styles.productTitle}>{title}</span>
            <p className={styles.productPrice}>
              {price_r.includes('You can purchase from') && price_w.includes('You can purchase from') ? (
                <span className={styles.priceLabel}>{priceTranslation[language]}</span>
              ) : (
                <>
                  <span className={styles.priceLabel}>
                    Price: {getCurrencySymbol(region, price_r)}
                    {price_r}
                    {/* <Tooltip
                      content={`${retailtPrice[language]} ${(r_amount || '').replace(/from|to/g, (match) =>
                        match === 'from' ? headerPriceTranslations[language][0] : headerPriceTranslations[language][1]
                      )}.`}
                    >
                      <span className={styles.infoIcon}>
                        <Info size={14} />
                      </span>
                    </Tooltip> */}
                  </span>
                  <br />
                  {price_w && price_w.trim() !== '' && includeWPrice !== false ? (
                    <span className={styles.priceLabel}>
                      W-sale: {getCurrencySymbol(region, price_w)}
                      {price_w}
                      {/* <Tooltip
                        content={`${whPrice[language]} ${(w_amount || '').replace(/from/g, (match) =>
                          match === 'from' ? headerPriceTranslations[language][0] : headerPriceTranslations[language][1]
                        )}.`}
                      >
                        <span className={styles.infoIcon}>
                          <Info size={14} />
                        </span>
                      </Tooltip> */}
                    </span>
                  ) : (
                    <span className={styles.priceLabel} style={{ visibility: 'hidden' }}></span>
                  )}

                  {price_w_add && price_w_add.trim() !== '' && includeAddWPrice !== false ? (
                    <span className={styles.priceLabel}>
                      W-sale+: {getCurrencySymbol(region, price_w_add)}
                      {price_w_add}
                      {/* <Tooltip
                        content={`${whAddPrice[language]} ${(w_amount_add || '').replace(/from/g, (match) =>
                          match === 'from' ? headerPriceTranslations[language][0] : headerPriceTranslations[language][1]
                        )}.`}
                      >
                        <span className={styles.infoIcon}>
                          <Info size={14} />
                        </span>
                      </Tooltip> */}
                    </span>
                  ) : (
                    <span className={styles.priceLabel} style={{ visibility: 'hidden' }}></span>
                  )}
                </>
              )}
            </p>

            {description || composition ? (
              <>
                {description && <p className={styles.productDescription}>{description}</p>}
                {composition && category === 'Mesoneedles & Cannulas' ? (
                  parseMesoneedleComposition(composition)?.length ? (
                    <>
                      <div className={styles.toppingGrid}>
                        {parseMesoneedleComposition(composition).map((item, idx) => (
                          <div
                            key={idx}
                            className={`${styles.toppingCard} 
                  ${selectedComposition === item ? styles.selected : ''} 
                  ${compositionError && selectedComposition !== item ? styles.errorCard : ''}`}
                            onClick={() => {
                              setSelectedComposition(item);
                              setCompositionError(false);
                            }}
                          >
                            <div className={styles.toppingTitle}>{item}</div>
                          </div>
                        ))}
                      </div>
                      {compositionError && <p className={styles.errorText}>Please select a type</p>}
                    </>
                  ) : (
                    <p className={styles.productDescription}>{composition}</p>
                  )
                ) : (
                  <p className={styles.productDescription}>{composition}</p>
                )}
              </>
            ) : (
              <>
                {needle_type && <p className={styles.gageDescription}>Needle Type: {needle_type}</p>}
                {needle_gage && <p className={styles.gageDescription}>Needle Gauge: {needle_gage}</p>}
                {needle_mm && <p className={styles.gageDescription}>Needle Length: {needle_mm}mm</p>}
                {thread_type && <p className={styles.gageDescription}>Thread Type: {thread_type}</p>}
                {thread_gage && <p className={styles.gageDescription}>Thread Gauge: {thread_gage}</p>}
                {thread_mm && <p className={styles.gageDescription}>Thread Length: {thread_mm}mm</p>}
              </>
            )}
            <div className={styles.productActions}>
              <QuantitySelector value={quantity} onChange={setQuantity} />
              <button className={`${styles.addToCartButton} ${added ? styles.added : ''}`} onClick={handleAdd}>
                <ShoppingCart size={16} />
                {added ? addedToCartBtn[language] : addToCartBtn[language]}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
